export default __webpack_public_path__ + "static/cellfina-1-d43f315c2cb29704296c6f60d1f7e139.jpg";